import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import {
  AwesomeIcon,
  S_AwesomeIcon,
} from "component_old/micro/view/AwesomeIcon"
import { EColors, EGrads, EHovers, EShadows } from "libs/style/styling"
import React from "react"
import styled, { css } from "styled-components/macro"

interface Props {
  icon: IconDefinition
  type: "primary" | "white"
  shadow?: EShadows
  disabled?: boolean
  onClick?: () => void
  className?: string
}

export const CircleIconButton = (props: Props): JSX.Element => {
  return (
    <S_CircleIconButton
      type={props.type}
      shadow={props.shadow}
      onClick={props.onClick}
      disabled={props.disabled}
      className={props.className}
    >
      <AwesomeIcon icon={props.icon} iconSize="10px" color={EColors.DARK} />
    </S_CircleIconButton>
  )
}

export const S_CircleIconButton = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: ${props => props.shadow};
  flex-shrink: 0;
  ${S_AwesomeIcon} {
    svg {
      font-size: 12px;
    }
    margin: 0px 0 0 0;
    @media only screen and (min-width: 1260px) {
      margin: 0;
    }
  }
  ${props => {
    if (props.type === "primary") {
      return css`
        ${props => {
          if (props.disabled) {
            return css`
              background: ${EColors.GREY3};
              color: ${EColors.DARK};
              cursor: not-allowed;
            `
          } else {
            return css`
              background: ${EGrads.ACC1_GRAD};
              color: ${EColors.DARK};
              &:hover {
                box-shadow: ${EHovers.LIGHT2}, ${props => props.shadow ?? "0 0"};
              }
            `
          }
        }};
      `
    } else if (props.type === "white") {
      return css`
        background-color: ${EColors.WHITE};
        &:hover {
          box-shadow: ${EHovers.DARK1}, ${props => props.shadow ?? "0 0"};
        }
      `
    }
  }}
  @media only screen and (min-width: 1260px) {
    width: 50px;
    height: 50px;
    ${S_AwesomeIcon} {
      svg {
        font-size: 20px;
        margin: 2px 0 0 0;
      }
    }
  }
`
